import React, { Component } from 'react'
import { createStyles, WithStyles, withStyles, Typography, IconButton, Menu, MenuItem, ListItemIcon, ListItemText, Paper, Icon, Box } from '@material-ui/core'
import { connect } from 'react-redux'
import { Dispatch } from 'redux';
import MuiTheme from '../MuiTheme';
import { ReduxStore } from '../stores';
import clsx from 'clsx'
import { RouteComponentProps, withRouter } from 'react-router';

interface IStateProps { }

interface IDispatchProps { }

interface IState {
    anchorEl: any
}

export interface SimpleCardOptionsConfig { icon: string, label: string, handler?: (entity: any) => void }

interface IProps extends WithStyles<typeof STYLES>, IStateProps, IDispatchProps, RouteComponentProps {
    title?: string
    description?: string
    optionsConfig?: Array<SimpleCardOptionsConfig>
    link?: string
    entity?: any
    multiline?: boolean
    onclick?: () => void
}

class SimpleTextCard extends Component<IProps, IState> {

    constructor(props: IProps) {
        super(props);
        this.state = {
            anchorEl: null
        }
    }

    closeOptions = () => {
        this.setState({ anchorEl: null })
    }

    cardClicked = () => {
        this.props.link && this.props.history.push(this.props.link);
        typeof this.props.onclick === 'function' && this.props.onclick();
    }

    render() {
        const { classes, description, title = '', optionsConfig, entity, multiline = false } = this.props
        const { anchorEl } = this.state;
        const open = Boolean(anchorEl);
        return (
            <div>
                <Paper className={classes.paper} >
                    <div onClick={this.cardClicked} className={clsx(classes.cardContent, { [classes.withDescription]: description && title })} >
                        {!entity.isPublished ? <Icon fontSize={'small'} color='error' >lock</Icon> : null}
                        {title && <Typography variant='h5' style={multiline ? { whiteSpace: 'pre-wrap' } : {}} >{title}</Typography>}
                        {description ? <Typography variant='body2' >{description}</Typography> : null}
                        {
                            description || !optionsConfig
                                ? null
                                :
                                <Box position={'absolute'} right={0} bottom={0} >
                                    <IconButton onClick={e => { this.setState({ anchorEl: e.target }); e.stopPropagation(); }} >
                                        <i className={'material-icons'} >more_vert</i>
                                    </IconButton>
                                </Box>
                        }
                    </div>
                    {
                        description && optionsConfig
                            ?
                            <Box position={'absolute'} right={0} bottom={0} >
                                <IconButton className={classes.absoluteOptions} onClick={e => this.setState({ anchorEl: e.target })} >
                                    <i className={'material-icons'} >more_vert</i>
                                </IconButton>
                            </Box>
                            : null
                    }
                    <Menu open={open} anchorEl={anchorEl} onClose={this.closeOptions} >
                        {
                            this.props.optionsConfig &&
                            (this.props.optionsConfig).map((item, index) => {
                                return (
                                    <MenuItem dense key={index} button onClick={e => { item.handler && item.handler(entity); this.closeOptions() }} >
                                        <ListItemIcon><i className={'material-icons'}>{item.icon}</i></ListItemIcon>
                                        <ListItemText>{item.label}</ListItemText>
                                    </MenuItem>
                                )
                            })
                        }
                    </Menu>
                </Paper>
            </div>
        )
    }
}

const mapStateToProps = (state: ReduxStore): IStateProps => ({

})

const mapDispatchToProps = (dispatch: Dispatch<any>): IDispatchProps => ({

})

const STYLES = (theme: typeof MuiTheme) => createStyles({
    paper: {
        minWidth: 320,
        position: 'relative',
        padding: '10px 45px 10px 10px',
        cursor: 'pointer'
    },
    cardContent: {
        display: 'flex',
        alignItems: 'center',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        '& > h5': {
            minWidth: 260,
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap'
        },
        '& > span': {
            marginRight: 10
        }
    },
    withDescription: {
        display: 'block'
    },
    absoluteOptions: {
        position: 'absolute',
        right: 0, bottom: 0
    },
    noPadding: {
        padding: 'unset',
        '&:last-child': {
            padding: 'unset',
            paddingLeft: 32
        },
        paddingLeft: 32
    }
})

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(withStyles(STYLES)(SimpleTextCard)))